import React from 'react';
import { motion } from 'framer-motion';
export function IntroSection() {
  return <section id="introduccion" className="min-h-screen py-24 px-6 lg:px-16 bg-white relative" data-id="element-256">
      <div className="max-w-3xl mx-auto" data-id="element-257">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-258">
          <h2 className="text-gold font-medium tracking-widest uppercase text-sm mb-4" data-id="element-259">
            Introducción
          </h2>
          <h3 className="font-serif text-4xl lg:text-5xl text-darkBrown font-bold mb-10 leading-tight" data-id="element-260">
            El secreto no es comer menos, es{' '}
            <span className="italic text-gold" data-id="element-261">desinflamar</span>.
          </h3>
        </motion.div>

        <div className="space-y-8 text-body text-darkBrown/80" data-id="element-262">
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} data-id="element-263">
            Durante décadas nos han enseñado que para perder peso y mantenernos
            saludables debemos contar calorías, pasar hambre y someternos a
            dietas restrictivas. Sin embargo, si has pasado la barrera de los 60
            años, probablemente te hayas dado cuenta de que estas estrategias ya
            no funcionan como antes.
          </motion.p>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-264">
            La razón es simple pero profunda: tu cuerpo no está acumulando grasa
            por exceso de comida, está acumulando grasa como un mecanismo de
            defensa contra la{' '}
            <strong className="text-darkBrown font-semibold" data-id="element-265">
              inflamación crónica
            </strong>
            .
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="bg-lightGold p-8 rounded-2xl border border-gold/20 my-12 relative overflow-hidden" data-id="element-266">
            <div className="absolute top-0 left-0 w-2 h-full bg-gold" data-id="element-267"></div>
            <h4 className="font-serif text-2xl text-darkBrown font-bold mb-4" data-id="element-268">
              La trampa del Cortisol
            </h4>
            <p className="mb-4" data-id="element-269">
              Después de la menopausia, nuestros niveles hormonales cambian
              drásticamente. Cuando intentamos "comer menos" o hacemos dietas
              estrictas, nuestro cuerpo, que ya está experimentando cambios, lo
              interpreta como una señal de peligro o hambruna.
            </p>
            <p data-id="element-270">
              Esto dispara la producción de <strong data-id="element-271">cortisol</strong>, la
              hormona del estrés. El cortisol alto le da una orden directa a tu
              metabolismo:{' '}
              <em data-id="element-272">
                "Guarda toda la energía posible alrededor de los órganos
                vitales"
              </em>
              . ¿El resultado? Esa obstinada grasa abdominal que parece
              imposible de eliminar, sin importar cuánto te esfuerces.
            </p>
          </motion.div>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} data-id="element-273">
            El Metabolismo Dorado no es una dieta. Es un protocolo diseñado
            específicamente para la biología de la mujer madura. Al apagar el
            "fuego interno" de la inflamación, le damos permiso a nuestro cuerpo
            para soltar el peso retenido, recuperar la energía vital y aliviar
            los dolores articulares.
          </motion.p>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.5
        }} data-id="element-274">
            En los próximos 14 días, aprenderás a nutrir tus células, a calmar
            tu sistema nervioso y a reactivar tu metabolismo de una manera
            gentil, deliciosa y profundamente sanadora.
          </motion.p>
        </div>
      </div>
    </section>;
}